var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cashwyre-service"},[_c('Cashwyre4BusinessServices'),_c('BusinessCallToAction')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }